import { render, staticRenderFns } from "./skip-links.component.vue?vue&type=template&id=53aab5fd&"
import script from "./skip-links.component.vue?vue&type=script&lang=ts&"
export * from "./skip-links.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports